<div class="content-block-main overflow-y-auto overflow-x-device" appSpin [spinnerConfig]="spinnerConfig()">
  <div class="Cover-Page" id="after1">
    <div class="d-flex flex-row align-items-start w-100">
      <div
        class="d-flex flex-column align-items-center justify-content-center page a4 report-sheet v-center show-draft mb-3"
        [ngClass]="{'show-draft':isShowDraft}"
        [ngStyle]="{'border':router.url === '/dashboard/ntrdashboard/FinancialStatement/doc/financialstatementexport' ? 'none' : 'default' }">
        <div class="report-sheet-body">
          <div class="report-sheet-body-content field-with-noborder">
            <ng-container *ngIf="acl?.hasEngViewEdit else showCoverText">
              <div class="mrgBtm" (click)="editDeable ? '' : openEditor()"
                [ngClass]="{'editable-component': (router.url !== '/dashboard/ntrdashboard/FinancialStatement/doc/financialstatementexport') && !editDeable && shortCutMenuDetails.isenglock != 1}">
                <div [innerHtml]="coverContent | safeHtml"></div>
                <!-- <div
              *ngIf="router.url !== ('/dashboard/ntrdashboard/FinancialStatement/doc/financialstatementexport') && !editDeable && shortCutMenuDetails.isenglock != 1"
              class="edit">
            <i class="fa-regular fa-pen"></i></div> -->
              </div>
            </ng-container>
            <ng-template #showCoverText>
              <div class="mrgBtm">
                <div [innerHtml]="coverContent | safeHtml"></div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- inorder to avoid dialog flickr issue loading the editor earlier in background-->
<div [hidden]="true">
  <tinymce [(ngModel)]="editorContent" [config]="config"></tinymce>
</div>
<!--editor dialog-->
<ng-template #textEditor>
  <div class="countable-dialog" style="width:800px; max-width: 100%;">
    <div mat-dialog-title class="dialog-header">
      <h4 class="title">Edit Cover</h4>
      <button mat-button class="close" [mat-dialog-close]="false" (click)="closeDialog()">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div mat-dialog-content class="dialog-body-content px-0">
      <tinymce [(ngModel)]="editorContent" [config]="config"></tinymce>
    </div>
    <div mat-dialog-actions class="dialog-footer button-group">
      <button mat-button mat-stroked-button color="dark" class="button-medium" [mat-dialog-close]="false"
        (click)="closeDialog()">Cancel</button>
      <button mat-button mat-flat-button color="primary" class="button-medium" [mat-dialog-close]="true"
        (click)="saveJSON(true)">Save</button>
    </div>
  </div>
</ng-template>